import { Box, Button, Skeleton, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect } from 'react';
import axios from 'axios';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import veg from "../Assets/product_management/Foodmark.svg"
import nonVeg from "../Assets/product_management/non-veg.svg"
import { updateInventoryDetail, updateInventoryDetailsModal, updateInventryHubsupervisors, updateSelectedInventoryId, updateallInventryDetails, updateinventoryDetailsEdit } from "../Redux/inventory";
import { useState } from "react";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { blobSrc } from '../utils/blobUrl';
import Tooltip from '@mui/material/Tooltip';
import CustomAxios from "../utils/CustomAxios";
import { useDateformate, useGetInventoryDetails } from "../Components/globalFunctions";
import { useNavigate } from "react-router-dom";
import { updatepageName } from "../Redux/page";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { keyframes } from '@mui/material/styles';



// Add blinking animation with reduced motion support
const blinkAnimation = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

// Helper: parse units safely (supports "10.45" and 10.45)
const toUnits = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n >= 0 ? n : null;
};

// Stock status based on Capacity In Stock (available_units)
const getStockStatusFromUnits = (units) => {
    if (units === null) return 'unknown';
    if (units === 0) return 'outofstock';
    if (units <= 5) return 'lowstock';
    return 'instock';
};

export function InventoryDetailsTable() {
    const authToken = localStorage.getItem('authtoken');
    const toast = useRef(null);
    const products = useSelector(state => state.products.products)
    const edit = useSelector(state => state.inventory.inventoryDetailsEdit)
    const search = useSelector(state => state.page.searchProduct)
    const product_search = useSelector(state => state.inventory.inventoryProductSearch)
    // const inventoryDetails = useSelector(state => state.inventory.inventory_detail)
    const inventoryDetails = useSelector(state => state.inventory.allInventryDetails)
    const inventories = useSelector(state => state.inventory.inventory)
    const supervisors = useSelector(state => state.inventory.supervisors)
    const [details, setDetails] = useState([])
    const getInventeroryDetails = useGetInventoryDetails()
    const inventoryDetailsLoading  = useSelector(state => state.inventory.inventoryDetailsLoading);
    const dateFormat = useDateformate()
    const dispatch = useDispatch();
    const navigate = useNavigate()
    useEffect(()=>{
        console.log(inventoryDetails)
        setDetails(inventoryDetails)
    },[inventoryDetails])

    useEffect(() => {
        let filtered = [];
        if (inventoryDetails?.length > 0 && products?.length > 0 && inventories?.length > 0) {
            const updatedInventoryDetails = inventoryDetails?.map((inventory) => {
                if (products?.some(p => p.value === inventory.product_id)) {
                    const product = products.find(p => p.value === inventory.product_id);
                    filtered = inventories?.filter((item) => item.name == inventory.place)
                    console.log("------", filtered);
                    if(filtered.length>0){
                          return {
                        ...inventory,
                        // details_id: filtered[0].value,
                        // inventoryDetails_id_original: inventory.id,
                        image_urls:product.image_urls,
                        item_name:product.item_name,
                        item_category:product.item_category,
                        item_criteria: product.item_criteria,
                    };
                    }
                    else{
                        return {
                            ...inventory,
                        };
                    }
                  
                }
                console.log(inventory)
                return inventory;
            });
            if (inventoryDetails?.length > 0 && supervisors?.length > 0 && filtered?.length > 0 ) {
                const commonNames = supervisors?.filter(obj1 => filtered[0].supervisors?.some(obj2 => obj1.id === obj2.id))
                    .map(obj => obj.name);
                console.log(commonNames);
                dispatch(updateInventryHubsupervisors(commonNames))
            }

            setDetails(updatedInventoryDetails)
        }
    }, [inventoryDetails, products, inventories, supervisors]);

  
console.log("--------------->>>",details.length,inventoryDetailsLoading);

    return (<Box>
        <Toast ref={toast} />
        <Typography sx={{fontSize: "16px", fontWeight: "700", lineHeight: "24px"}}>Inventory Details List</Typography>
        <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                <TableHead style={{ backgroundColor: "background.upload" }}>
                    <TableRow >
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Images</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Place</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Products</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Capacity In Stock</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Availability</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Date added</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Expiry Date</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Total Units</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="right">Category</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="right">Criteria</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="right">BoGo</TableCell>
                        <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Actions</TableCell>


                    </TableRow>
                </TableHead>
                <TableBody>
                    {details?.length>0?
                    details?.filter((item) => {
                        if (!item.item_name) return false;
                    
                        return product_search !== ""
                          ? item.item_name.toLowerCase().includes(product_search?.toLowerCase())
                          : true; })?.map((item,ind) => {
                    const units = toUnits(item?.available_units);
                    const stockStatus = getStockStatusFromUnits(units);
                    const isLowStock = stockStatus === 'lowstock';

                        console.log(item)
                        return (<> {
                            <TableRow
                                key={item.id}
                                sx={{
                                    ...(isLowStock && {
                                        backgroundColor: '#ffebee', // Light red background
                                        animation: `${blinkAnimation} 1.5s ease-in-out infinite`,
                                        // EDGE CASE: Respect user preferences for reduced motion
                                        '@media (prefers-reduced-motion: reduce)': {
                                            animation: 'none',
                                            backgroundColor: '#ffebee',
                                        }
                                    })
                                }}
                            >
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }} >{ind+1}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }} onClick={() => (navigate("/home/inventoryBatchList"), dispatch(updatepageName("inventoryBatchList")))}>
                                    {item?.image_urls?.map((img) => (<Box component='img' src={blobSrc(img)} sx={{ width: "40px", height: "40px", borderRadius: "8px", marginRight: "10px" }}></Box>))}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item.place}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item.item_name}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item.available_units+" "+(item.units=="kilogram"?"Kg":item.units=="litre"?"Ltr":item.units=="grams"?"gms":"")}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>
                                    {(() => {
                                        // EDGE CASE: Handle unknown status gracefully
                                        if (stockStatus === 'unknown') {
                                            return <Box sx={{ width:"80px",height:"22px",backgroundColor:"#9e9e9e",border:"1px solid",borderColor:"#9e9e9e",borderRadius:"2px",padding:"1px 8px" ,display:"flex",justifyContent:"center"}}>
                                                <Typography sx={{fontSize:"12px",fontWeight:400,lineHeight:"20px",color:"white",textAlign:"center",textTransform:"uppercase", width:"80px"}}>unknown</Typography>
                                            </Box>;
                                        } else if (stockStatus === 'outofstock') {
                                            return <Box sx={{ width:"120px",height:"22px",backgroundColor:"button.backgroundDelete",border:"1px solid",borderColor:"borders.red",borderRadius:"2px",padding:"1px 8px" ,display:"flex",justifyContent:"center"}}>
                                                <Typography sx={{fontSize:"12px",fontWeight:400,lineHeight:"20px",color:"borders.red",textAlign:"center",textTransform:"uppercase", width:"88px"}}> out of stock</Typography>
                                            </Box>;
                                        } else if (stockStatus === 'lowstock') {
                                            return (
                                                <Box
                                                    sx={{
                                                        minWidth: "96px",
                                                        height: "22px",
                                                        backgroundColor: "#dc3545",
                                                        border: "1px solid",
                                                        borderColor: "#dc3545",
                                                        borderRadius: "2px",
                                                        padding: "1px 8px",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "12px",
                                                            fontWeight: 400,
                                                            lineHeight: "20px",
                                                            color: "white",
                                                            textAlign: "center",
                                                            textTransform: "uppercase",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        low stock
                                                    </Typography>
                                                </Box>
                                            );
                                        } else {
                                            return <Box sx={{ width:"67px",height:"22px",backgroundColor:"button.backgroundEdit",border:"1px solid",borderColor:"borders.green" ,borderRadius:"2px",padding:"1px 8px",display:"flex",justifyContent:"center"}} >
                                                <Typography sx={{textAlign:"center",fontSize:"12px",fontWeight:400,lineHeight:"20px",color:"borders.green",textTransform:"uppercase",width:"67px"}}>instock</Typography>
                                            </Box>;
                                        }
                                    })()}
                                </TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{dateFormat(item.created_on)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{dateFormat(item.expired_on)}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item.total_units}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item.item_category}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item.item_criteria == 'veg' ? <Box component='img' src={veg}></Box> : <Box component='img' src={nonVeg}></Box>}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white" }}>{item?.offer?.length > 0 ? <Box sx={{ width: "67px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }} ><Typography sx={{ textAlign: "center", fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green", textTransform: "uppercase", width: "67px" }}>BOGO</Typography></Box>:'-- --'}</TableCell>
                                <TableCell sx={{ textAlign: "left", textTransform: "capitalize", backgroundColor: isLowStock ? "transparent" : "white", display: "flex",gap:"8px",alignItems:"center"}}>
                                <Tooltip title="View inventory batches" arrow>
                                        <IconButton sx={{ textTransform: "none" }} onClick={() => (navigate("/home/inventoryBatchList"), dispatch(updatepageName("inventoryBatchList")), dispatch(updateSelectedInventoryId(item)))}><VisibilityIcon /></IconButton>
                                </Tooltip>
                                </TableCell>
                            </TableRow>}</>)
                    })
                    : <TableRow  >
                    {inventoryDetailsLoading?<TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white",height:"200px",fontWeight:"700" }} colSpan={12}>
                        <Box>
                            <Box sx={{ width: "80%" }}>
                                <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                            </Box>
                            <Box sx={{ width: "80%" }}>
                                <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                            </Box>
                            <Box sx={{ width: "80%" }}>
                                <Skeleton animation="wave" sx={{ height: "60px", background: "rgb(0 0 0 / 6%)" }} />
                                <Skeleton animation="wave" sx={{ background: "rgb(0 0 0 / 6%)" }} />
                            </Box>
                        </Box>
                    </TableCell>:
                                <TableCell sx={{ textAlign: "center", textTransform: "capitalize", backgroundColor: "white", height: "200px", fontWeight: "700" }} colSpan={12}>No Inventory Details Available</TableCell>}
                </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Box>)
}